export const legalTr = {
  fr: {
    updated: "Dernière mise à jour",
    updatedDate: "Février 2026",
    contactLabel: "Contact",
    contactValue: "gemprice@gemprice.org",
    privacy: {
      title: "Politique de confidentialité",
      intro:
        "GEM PRICE respecte votre vie privée et s'engage à protéger vos données à caractère personnel conformément au Règlement Général sur la Protection des Données (RGPD — UE 2016/679) et à la loi Informatique et Libertés.",
      sections: [
        {
          h: "1. Responsable du traitement",
          p:
            "Le responsable du traitement est GEM PRICE, joignable à l'adresse gemprice@gemprice.org. Pour toute question relative à cette politique ou à l'exercice de vos droits, écrivez-nous à cette adresse.",
        },
        {
          h: "2. Données collectées",
          p:
            "Nous collectons uniquement les données strictement nécessaires au fonctionnement du service : adresse email (compte et facturation), informations de facturation (traitées par notre prestataire Stripe), et données techniques anonymes (langue, page consultée) via des cookies analytiques.",
        },
        {
          h: "3. Finalités du traitement",
          p:
            "Vos données sont utilisées pour : gérer votre abonnement annuel (79 €/an) et l'accès aux tarifications ; assurer la facturation et le paiement sécurisé ; améliorer l'expérience utilisateur ; répondre à vos demandes de support.",
        },
        {
          h: "4. Base légale",
          p:
            "Le traitement repose sur l'exécution du contrat d'abonnement (art. 6.1.b RGPD), sur votre consentement pour les cookies analytiques (art. 6.1.a), et sur l'intérêt légitime de GEM PRICE à sécuriser son service.",
        },
        {
          h: "5. Paiement et Stripe",
          p:
            "Les paiements sont traités exclusivement par Stripe Payments Europe, Limited. GEM PRICE ne stocke ni ne voit vos coordonnées bancaires. Consultez la politique Stripe : https://stripe.com/privacy",
        },
        {
          h: "6. Durée de conservation",
          p:
            "Données de compte : durée de l'abonnement + 3 ans (prospection). Données de facturation : 10 ans (obligation légale comptable). Cookies analytiques : 13 mois maximum.",
        },
        {
          h: "7. Vos droits",
          p:
            "Conformément au RGPD, vous disposez d'un droit d'accès, de rectification, d'effacement, de limitation, d'opposition et de portabilité de vos données. Exercez-les à gemprice@gemprice.org. Vous pouvez également introduire une réclamation auprès de la CNIL (www.cnil.fr).",
        },
        {
          h: "8. Cookies",
          p:
            "Nous utilisons des cookies fonctionnels (nécessaires au fonctionnement du site, notamment pour mémoriser votre statut d'abonné) et, sous réserve de votre consentement, des cookies analytiques anonymes. Vous pouvez à tout moment gérer vos préférences via votre navigateur.",
        },
        {
          h: "9. Sécurité",
          p:
            "GEM PRICE met en œuvre des mesures techniques et organisationnelles appropriées pour garantir la sécurité de vos données : chiffrement TLS, hébergement européen, accès restreint et audits réguliers.",
        },
        {
          h: "10. Modifications",
          p:
            "Cette politique peut être mise à jour pour refléter des évolutions légales ou fonctionnelles. La date de dernière mise à jour est indiquée en haut de page.",
        },
      ],
    },
    terms: {
      title: "Conditions générales de vente et d'utilisation",
      intro:
        "Les présentes conditions générales régissent l'accès et l'utilisation du service GEM PRICE, plateforme d'informations gemmologiques et de tarifications certifiées des pierres précieuses.",
      sections: [
        {
          h: "1. Éditeur",
          p:
            "Le service GEM PRICE est édité par GEM PRICE, joignable à gemprice@gemprice.org, accessible à l'adresse https://gemprice.org.",
        },
        {
          h: "2. Objet du service",
          p:
            "GEM PRICE propose un accès à des informations gemmologiques (laboratoires, formation, traitements, synthétiques, journal mensuel) en libre accès, et à des grilles de tarifications détaillées des saphirs, rubis et émeraudes par pays d'origine et par poids (carat) sur abonnement payant.",
        },
        {
          h: "3. Abonnement",
          p:
            "L'abonnement Premium est proposé au tarif unique de 79 € TTC par an, reconductible tacitement. Il donne accès à l'ensemble des grilles de tarifications des trois pierres (saphir, rubis, émeraude) pour tous les pays référencés.",
        },
        {
          h: "4. Modalités de paiement",
          p:
            "Le paiement s'effectue en ligne par carte bancaire via Stripe. Les prix sont indiqués en euros TTC. Une facture est envoyée par email après chaque paiement.",
        },
        {
          h: "5. Droit de rétractation",
          p:
            "Conformément à l'article L.221-28 du Code de la consommation, l'accès immédiat au contenu numérique après paiement entraîne la renonciation au droit de rétractation de 14 jours, sous réserve de votre consentement exprès lors de la souscription.",
        },
        {
          h: "6. Résiliation",
          p:
            "Vous pouvez résilier votre abonnement à tout moment depuis votre espace client ou par email à gemprice@gemprice.org. La résiliation prend effet au terme de la période annuelle en cours, sans remboursement au prorata.",
        },
        {
          h: "7. Propriété intellectuelle",
          p:
            "L'ensemble des contenus (textes, images, données, grilles tarifaires, articles du journal) est protégé par le droit d'auteur et reste la propriété exclusive de GEM PRICE. Toute reproduction, extraction ou diffusion sans autorisation écrite est interdite.",
        },
        {
          h: "8. Limitation de responsabilité",
          p:
            "Les informations et tarifications fournies par GEM PRICE sont indicatives et issues de sources professionnelles reconnues. Elles ne constituent pas une expertise ou une garantie de valeur. GEM PRICE ne peut être tenu responsable des décisions d'achat prises sur la base de ces informations.",
        },
        {
          h: "9. Données personnelles",
          p:
            "Le traitement de vos données est décrit dans notre Politique de confidentialité, accessible depuis le pied de page.",
        },
        {
          h: "10. Droit applicable",
          p:
            "Les présentes conditions sont régies par le droit français. En cas de litige, une solution amiable sera recherchée avant toute action judiciaire. À défaut, les tribunaux compétents seront ceux du ressort du siège de GEM PRICE.",
        },
      ],
    },
  },
  en: {
    updated: "Last updated",
    updatedDate: "February 2026",
    contactLabel: "Contact",
    contactValue: "gemprice@gemprice.org",
    privacy: {
      title: "Privacy policy",
      intro:
        "GEM PRICE respects your privacy and is committed to protecting your personal data in accordance with the General Data Protection Regulation (GDPR — EU 2016/679).",
      sections: [
        {
          h: "1. Data controller",
          p:
            "The data controller is GEM PRICE, reachable at gemprice@gemprice.org. For any question regarding this policy or the exercise of your rights, please contact us at this address.",
        },
        {
          h: "2. Data collected",
          p:
            "We only collect the data strictly necessary to operate the service: email address (account and billing), billing information (processed by our partner Stripe), and anonymous technical data (language, page visited) via analytics cookies.",
        },
        {
          h: "3. Purpose of processing",
          p:
            "Your data is used to: manage your annual subscription (€79/year) and access to pricing; provide billing and secure payment; improve user experience; respond to your support requests.",
        },
        {
          h: "4. Legal basis",
          p:
            "Processing is based on the performance of the subscription contract (art. 6.1.b GDPR), on your consent for analytics cookies (art. 6.1.a), and on GEM PRICE's legitimate interest in securing its service.",
        },
        {
          h: "5. Payment and Stripe",
          p:
            "Payments are processed exclusively by Stripe Payments Europe, Limited. GEM PRICE neither stores nor sees your banking details. See Stripe's policy: https://stripe.com/privacy",
        },
        {
          h: "6. Retention period",
          p:
            "Account data: subscription term + 3 years. Billing data: 10 years (legal accounting obligation). Analytics cookies: 13 months maximum.",
        },
        {
          h: "7. Your rights",
          p:
            "In accordance with the GDPR, you have rights of access, rectification, erasure, restriction, objection and portability. Exercise them at gemprice@gemprice.org. You may also lodge a complaint with the CNIL (www.cnil.fr) or your local data protection authority.",
        },
        {
          h: "8. Cookies",
          p:
            "We use functional cookies (necessary to operate the site, in particular to remember your subscriber status) and, subject to your consent, anonymous analytics cookies. You may manage your preferences at any time via your browser.",
        },
        {
          h: "9. Security",
          p:
            "GEM PRICE implements appropriate technical and organizational measures to ensure the security of your data: TLS encryption, European hosting, restricted access and regular audits.",
        },
        {
          h: "10. Changes",
          p:
            "This policy may be updated to reflect legal or functional changes. The date of the last update is indicated at the top of the page.",
        },
      ],
    },
    terms: {
      title: "Terms & conditions",
      intro:
        "These terms govern access to and use of the GEM PRICE service, a platform for gemmological information and certified pricing of precious stones.",
      sections: [
        {
          h: "1. Publisher",
          p:
            "The GEM PRICE service is published by GEM PRICE, reachable at gemprice@gemprice.org, accessible at https://gemprice.org.",
        },
        {
          h: "2. Purpose of the service",
          p:
            "GEM PRICE provides free access to gemmological information (laboratories, formation, treatments, synthetics, monthly journal), and paid subscription access to detailed pricing grids for sapphires, rubies and emeralds by country of origin and by weight (carat).",
        },
        {
          h: "3. Subscription",
          p:
            "The Premium subscription is offered at a single price of €79 (incl. tax) per year, renewable tacitly. It grants access to all pricing grids for the three stones (sapphire, ruby, emerald) for every referenced country.",
        },
        {
          h: "4. Payment terms",
          p:
            "Payment is made online by credit card via Stripe. Prices are shown in euros including tax. An invoice is sent by email after each payment.",
        },
        {
          h: "5. Right of withdrawal",
          p:
            "In accordance with Article L.221-28 of the French Consumer Code, immediate access to digital content after payment entails the waiver of the 14-day right of withdrawal, subject to your express consent upon subscription.",
        },
        {
          h: "6. Cancellation",
          p:
            "You may cancel your subscription at any time from your account or by email at gemprice@gemprice.org. Cancellation takes effect at the end of the current annual period, without pro rata refund.",
        },
        {
          h: "7. Intellectual property",
          p:
            "All content (texts, images, data, pricing grids, journal articles) is protected by copyright and remains the exclusive property of GEM PRICE. Any reproduction, extraction or distribution without written authorization is prohibited.",
        },
        {
          h: "8. Limitation of liability",
          p:
            "The information and pricing provided by GEM PRICE are indicative and drawn from recognized professional sources. They do not constitute an expertise or a guarantee of value. GEM PRICE cannot be held liable for purchase decisions made on the basis of this information.",
        },
        {
          h: "9. Personal data",
          p:
            "The processing of your data is described in our Privacy Policy, accessible from the footer.",
        },
        {
          h: "10. Governing law",
          p:
            "These terms are governed by French law. In the event of a dispute, an amicable solution will be sought before any legal action. Failing that, the competent courts shall be those of GEM PRICE's registered office.",
        },
      ],
    },
  },
};
